module.exports = __webpack_public_path__ + "static/media/nextButton.08eb4fd3.svg";